import { OrderSummary, TripDriverCache } from '@lib/types';

import { getRemainingTimeFromEstimatedMovingDuration } from './getRemainingTimeFromEstimatedMovingDuration';

import { DriverCache, OrderDriver } from '../types';

export function FromTripDriverCacheToOrderDriver(
  tripDriver: TripDriverCache,
): OrderDriver {
  const expectedRemainingTime =
    getRemainingTimeFromEstimatedMovingDuration(tripDriver);

  return {
    expectedRemainingTime,
    name: tripDriver.driverName,
    photo: tripDriver.driverPhoto,
    phoneNumber: tripDriver.driverPhoneNumber,
    uuid: tripDriver.driverUUID,
    customerUUID: tripDriver.customerUUID,
    tripStatus: tripDriver.tripStatus,
    location: tripDriver.location,
    acceptedTime: tripDriver.acceptedTime,
    estimatedMovingDuration: tripDriver.estimatedMovingDuration,
  };
}

export function fromTripsDriversToOrdersSummary(
  drivers: DriverCache[],
  orders: OrderSummary[],
): OrderSummary[] {
  drivers.map((driver) => {
    const order = orders.filter(
      (item: OrderSummary) => item.uuid === driver.orderUUID,
    )[0];

    const cache = FromTripDriverCacheToOrderDriver(driver.tripDriverCache);
    order.tripDriverCache = cache;
    return order;
  });

  return orders;
}
